// API Configuration for different environments
const config = {
  development: {
    apiBaseUrl: 'http://localhost:8080',
  },
  production: {
    apiBaseUrl: import.meta.env.VITE_API_URL || 'https://retirementpro-backend-cyaalojyva-uc.a.run.app',
  },
};

const environment = import.meta.env.MODE || 'development';
const currentConfig = config[environment];

export const API_BASE_URL = currentConfig.apiBaseUrl;

// Helper function to build API URLs
export const buildApiUrl = (endpoint) => {
  return `${API_BASE_URL}${endpoint}`;
};

export default currentConfig; 